import { Component, OnInit, Input } from '@angular/core';
import { CalendarSlotVM } from '../../models';
import { CounsellorWorkingHoursVM } from '../../models/CounsellorWorkingHoursVM';
import { Observable, Subscription } from 'rxjs';

@Component({
    selector: 'select-workinghours',
    templateUrl: './select-working-hours.component.html'
})
export class SelectWorkingHoursComponent implements OnInit {


    @Input() dayOfWeek: number = 0;
    @Input() slotTimes: [CounsellorWorkingHoursVM];
    @Input() selectedItems: CounsellorWorkingHoursVM[] = [];

    dayOfWorkLabel: string

    constructor() {

    }

    ngOnInit(): void {
        switch (this.dayOfWeek) {
            case 1:
                this.dayOfWorkLabel = "Monday";
                break;
            case 2:
                this.dayOfWorkLabel = "Tuesday";
                break;
            case 3:
                this.dayOfWorkLabel = "Wednesday";
                break;
            case 4:
                this.dayOfWorkLabel = "Thursday";
                break;
            case 5:
                this.dayOfWorkLabel = "Friday";
                break;
            case 6:
                this.dayOfWorkLabel = "Saturday";
                break;
            case 0:
                this.dayOfWorkLabel = "Sunday";
                break;
        }
    }

    addItem() {
        var newItem = new CounsellorWorkingHoursVM();
        newItem.dayOfWeek = this.dayOfWeek;
        newItem.startTime = this.slotTimes[0].startTime;
        newItem.endTime = this.slotTimes[0].endTime;

        this.selectedItems.push(newItem);
    }

    removeItem(item: any) {
        var index = this.selectedItems.indexOf(item, 0);
        if (index > -1) {
            this.selectedItems.splice(index, 1);
        }
    }

    noWorkingHours(): boolean {
        var noHours = true;
        if (this.selectedItems != null) {
            this.selectedItems.forEach((item) => {
                if (item.dayOfWeek == this.dayOfWeek) {
                    noHours = false;
                }
            });
        }

        return noHours;
    }

}